export const GAME_WIDTH = 400;
export const GAME_HEIGHT = 640;

export const GRAVITY = 0.32;
export const JUMP_VELOCITY = -8.2;
export const MOVE_SPEED = 3.1;
export const MAX_FALL_SPEED = 11;

export const PLAYER_SIZE = 40;
export const PLATFORM_WIDTH = 72;
export const CLOUD_IMAGE_SRC = '/images/cat_jump/cloud.png';
export const CAT_IMAGE_SRC = '/images/cat_jump/cat.png';
/** 이미지 상단 기준, 고양이가 서는 높이 비율 (0~1) */
export const CLOUD_STAND_RATIO = 0.56;
export const PLATFORM_COUNT = 10;
export const PLATFORM_GAP_MIN = 42;
export const PLATFORM_GAP_MAX = 72;

export const INITIAL_PLATFORM_COUNT = 8;
